var _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWeight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2951_3684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0625 2.25H3.9375C3.48995 2.25 3.06072 2.42779 2.74426 2.74426C2.42779 3.06072 2.25 3.48995 2.25 3.9375V23.0625C2.25 23.5101 2.42779 23.9393 2.74426 24.2557C3.06072 24.5722 3.48995 24.75 3.9375 24.75H23.0625C23.5101 24.75 23.9393 24.5722 24.2557 24.2557C24.5722 23.9393 24.75 23.5101 24.75 23.0625V3.9375C24.75 3.48995 24.5722 3.06072 24.2557 2.74426C23.9393 2.42779 23.5101 2.25 23.0625 2.25Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75 10.7179C8.62031 8.46787 10.8703 7.34286 13.5 7.34286C16.1297 7.34286 18.3797 8.46787 20.25 10.7179",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.4375C13.9476 17.4375 14.3768 17.2597 14.6932 16.9432C15.0097 16.6268 15.1875 16.1976 15.1875 15.75C15.1875 15.3024 15.0097 14.8732 14.6932 14.5568C14.3768 14.2403 13.9476 14.0625 13.5 14.0625C13.0524 14.0625 12.6232 14.2403 12.3068 14.5568C11.9903 14.8732 11.8125 15.3024 11.8125 15.75C11.8125 16.1976 11.9903 16.6268 12.3068 16.9432C12.6232 17.2597 13.0524 17.4375 13.5 17.4375Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6875 11.8125L13.5045 15.75",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2951_3684)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H27V27H0V0Z",
    fill: "#0272DA"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeight);
export default __webpack_public_path__ + "static/media/weight.dfd6bfe883c2d6da6900fa14ea837500.svg";
export { ForwardRef as ReactComponent };